import { lazy } from "react";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const Setting = ScreenLoader(lazy(() => import("../screens/Setting")));

export const SettingRoute = () => ({
  path: "setting",
  element: (
    <AuthGuard>
      <Setting />
    </AuthGuard>
  ),
});
